import { GenericFilter } from "./genericClass";

export class SignatureDocumentUsers {
    id: number;
    username: string;
    email: string;
    fullName: string;
    active: boolean;
    position: number;
    idStatus: number;
    internal: boolean;
    regDate: Date;
    signatureDate: Date;
    idSignature: number;
    onlyCopy: boolean;
    typeSigner: number;
    reasonRefuse: string;
    modFc: Date;
    message: string;
    disabled: boolean;
    role: string;
}

export class SignersInfo {
    id: number;
    username: string;
    active: boolean;
    position: number;
    idStatus: number;
    email: string;
    internal: boolean;
    fullName: string;
    onlyCopy: boolean;
    role: string;
}

export class SignatureDocument {
    id: number;
    idDocument: number;
    idType: number;
    active: boolean;
    regDate: Date;
    regUser: string;
    modUser: string;
    modFc: Date;
    documentCode: string;
    idClient: number;
    currentVersion: number;
    lang: string;
    documentUsers: SignatureDocumentUsers[];
    idStatus: number;
    idAttachment: number;
    reportConfig: string;
    manual: boolean;
}

export class SignatureBoxFilter extends GenericFilter {
    id: number;
    idStatus: number;
    idType: number;
    username: string;
    documentCode: string;
    idClient: number;
}

export class SignatureBox {
    id: number;
    username: string;
    documentCode: string;
    nameClient: number;
    idType: number;
    fullName: string;
    regDate: Date;
    nameStatus: string;
    idDocument: number;
    idClient: number;
    active: boolean;
    countUser: string;
    idStatus: number;
}

export enum SignatureStatusEnum {
    PENDING_SIGN=1, 
    CANCELLED=3, 
    SIGNED=2
}

export enum TypeSignersEnum {
    GENERATE_BY = 3,
    REVIEWED_BY = 1, 
    APPROVED_BY = 2
}